var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home page"},[_c('img',{attrs:{"src":"/img/rust.png"}}),_c('h1',[_vm._v("Welcome to the official website of RageCrew Gaming & Community")]),_c('h2',[_vm._v("RageCrew Servers - modded to perfection")])])
}]

export { render, staticRenderFns }